export default __webpack_public_path__ + "static/media/12_2.cd477796.jpg";